/* GearNas — accessible FAQ accordion */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-gn-faq-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-gn-faq-item]');
    if (!item) return;
    const panel = item.querySelector('[data-gn-faq-panel]');
    const isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
    if (panel) panel.hidden = isOpen;
  });
})();

